<template>
  <ubi-panel>
    <ubi-list-header slot="header"
                     :limits="limits"
                     :total="socialPostsEditoriaux.total"
                     :page.sync="page"
                     :limit.sync="limit"></ubi-list-header>
    <ubi-list-selection
        v-if="socialPostsEditoriaux && socialPostsEditoriaux.total > 0"
        slot="selection"
        :value="selectedIds"
        :current-page-ids="currentPageIds"
        @input="onListSelectionInput"
        @select="doSelect"
    ></ubi-list-selection>

    <template slot="actions">
      <div v-if="!selected.length">
        <el-button size="mini" v-if="isCardList" @click="setViewMode('list')"><em class="el-icon-s-fold"></em>{{ $t("users.listMode") }}</el-button>
        <el-button size="mini" v-if="isListView" @click="setViewMode('sticker')"><em class="el-icon-menu"></em>{{ $t("users.vignetteMode") }}</el-button>
      </div>
      <div v-else>
          <span>
            <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selectAllMode ? ((socialPostsEditoriaux && socialPostsEditoriaux.total) || selected.length) : selected.length }}) : {{ (' ') }}</span>
                        <el-button class="PostsList-remove" size="mini" style="margin-left: 5px"
                                   @click="deletePost(selected)">{{ $t("general.selection.remove") }}</el-button>
          </span>
      </div>
    </template>
    <ubi-list-footer
        slot="footer"
        v-if="socialPostsEditoriaux.total && socialPostsEditoriaux.total > 1"
        :limits="limits"
        :total="socialPostsEditoriaux.total"
        :page.sync="page"
        :limit.sync="limit"
    ></ubi-list-footer>

    <SocialPostCard
        :selected.sync="selected"
        :socialPosts="socialPostsEditoriaux"
        :loading-status="loadingStatus"
        :check-nb-diffusions-actives="checkNbDiffusionsActives"
        :is-post-fully-published="isPostFullyPublished"
        :store-module="'socialNetworkPosts'"
        type="Editoriaux"
        @edit-post="editPost"
        @delete-post="deletePost"
        @view-post="viewPost"
    ></SocialPostCard>

    <el-table ref="table"
              v-if="socialPostsEditoriaux && isListView"
              class="SocialPostsTable social-posts-editoriaux-table"
              :data="socialPostsEditoriaux.list"
              v-loading="loadingStatus"
              :row-class-name="editorialRowClassName"
              :cell-style="editorialCellStyle"
              style="width: 100%"
    >

      <el-table-column width="55" align="center">
        <template v-slot:header>
          <span></span>
        </template>
        <template v-slot="{ row: result }">
          <el-checkbox
              :value="selected.some(s => s.id === result.id)"
              @input="toggleRowSelection(result, $event)"
          />
        </template>
      </el-table-column>

      <el-table-column label="Publication" min-width="300">
        <template v-slot="{ row: result }">
          <el-row>
            <el-col :lg="5">
              <div v-if="possedeVideo(result) || possedeVideoUploadee(result)" style="text-align: center;">
                <img src="Images/picto-lecteur-video.png" width="60px" />
              </div>
              <div v-else-if="result.photoPrincipale !== false">
                <img width="60"
                     alt=""
                     :src="result.photoPrincipale.url_miniature"
                     :srcset="result.photoPrincipale.url_miniature"
                />
              </div>
            </el-col>
            <el-col :lg="17">
              <div>{{ result.titre }}</div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.publishOn')" min-width="120">
        <template v-slot="{ row: result }">
          <social-posts-list-table-presence-icons :post="result"></social-posts-list-table-presence-icons>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.publishedOn')" min-width="320">
        <template v-slot="{ row: result }">
          <social-posts-list-table-presence :post="result"></social-posts-list-table-presence>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.actions')" min-width="100" align="right">
        <template v-slot="{ row: result }">
          <div>
            <router-link :to="{ name: 'view-post-editorial', params: { id: result.id } }" v-if="isPostFullyPublished(result)" style="margin-right: 10px;">
              <em class="el-icon-view"></em>
            </router-link>
            <router-link :to="{ name: 'edit-post-editorial', params: { id: result.id } }" v-else style="margin-right: 10px;">
              <em class="el-icon-edit-outline"></em>
            </router-link>
            <em class="el-icon-delete" v-if="checkNbDiffusionsActives(result) === 0" @click="deletePost([result])"></em>

          </div>
        </template>
      </el-table-column>

    </el-table>

  </ubi-panel>
</template>

<script>

import SocialPostsListTablePresence from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresence'
import SocialPostsListTablePresenceIcons from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresenceIcons'
import { mapGetters, mapMutations, mapState } from 'vuex'
import UbiPanel from '@/components/Panel.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import SocialPostCard from '@/components/ui/SocialPostCard.vue'
import { possedeVideo, possedeVideoUploadee } from '@/services/socialNetworkTools'
import socialPostPublicationStatus from '@/mixins/socialPostPublicationStatus'
import UbiListSelection from '@/components/lists/ListSelection.vue'

export default {
  name: 'SocialPostsTableEditoriaux',
  components: {
    UbiListSelection,
    SocialPostCard,
    UbiListFooter,
    UbiListHeader,
    UbiPanel,
    SocialPostsListTablePresence,
    SocialPostsListTablePresenceIcons
  },
  mixins: [socialPostPublicationStatus],
  data () {
    return {
      limits: [5, 10, 20],
      selected: [],
      postsPublicationStatus: {},
      pendingMergePage: null,
      selectAllMode: false
    }
  },
  watch: {
    'filters.page' (newPage, oldPage) {
      if (this.selectAllMode && oldPage != null && newPage !== oldPage) {
        this.pendingMergePage = newPage
      }
    },
    'socialPostsEditoriaux.list': {
      async handler (list) {
        if (list && list.length > 0) {
          await this.checkPostsPublicationStatus()
        }
        if (
          this.selectAllMode &&
            this.pendingMergePage != null &&
            this.filters.page === this.pendingMergePage &&
            list &&
            list.length
        ) {
          const existingIds = new Set((this.selected || []).map(s => s.id))
          const toAdd = list.filter(item => !existingIds.has(item.id))
          this.selected = [...(this.selected || []), ...toAdd]
          this.pendingMergePage = null
        }
      },
      immediate: true
    }
  },
  computed: {
    /** Équivalent mapState('socialPostsTableEditoriaux', …) — forme explicite pour l'analyse statique / IDE. */
    filters () {
      return this.$store.state.socialPostsTableEditoriaux.filters
    },
    socialPostsEditoriaux () {
      return this.$store.state.socialPostsTableEditoriaux.socialPostsEditoriaux
    },
    loadingStatus () {
      return this.$store.state.socialPostsTableEditoriaux.loadingStatus
    },
    selection () {
      return this.$store.state.socialPostsTableEditoriaux.selection
    },
    /** Équivalent mapGetters('socialNetworkPosts', ['isListView', 'isCardList']) */
    isListView () {
      return this.$store.getters['socialNetworkPosts/isListView']
    },
    isCardList () {
      return this.$store.getters['socialNetworkPosts/isCardList']
    },
    page: {
      get () {
        return this.filters.page
      },
      set (value) {
        this.setPage(value)
        this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
      }
    },
    limit: {
      get () {
        return this.filters.limit
      },
      set (value) {
        this.setLimit(value)
        this.setPage(1)
        this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
      }
    },
    currentPageIds () {
      return (this.socialPostsEditoriaux.list || []).map(item => item.id)
    },
    selectedIds () {
      return (this.selected || []).map(s => s.id)
    }
  },
  mounted () {
    this.$store.commit('socialPostsTableEditoriaux/setSelection', [])
    this.$store.dispatch('socialPostsTableEditoriaux/loadSocialPostsEditoriaux')
  },
  methods: {
    possedeVideoUploadee,
    possedeVideo,
    ...mapMutations('socialPostsTableEditoriaux', [
      'setPage',
      'setSocialPostsEditoriaux',
      'setLimit',
      'setSelection'
    ]),
    setViewMode (view) {
      this.$store.commit('socialNetworkPosts/setView', view)
    },
    async checkPostsPublicationStatus () {
      if (!this.socialPostsEditoriaux || !this.socialPostsEditoriaux.list) return

      const statusPromises = this.socialPostsEditoriaux.list.map(async post => {
        const status = await this.checkPostPublicationStatus(post.id, 'editorial')
        return { postId: post.id, ...status }
      })

      const statuses = await Promise.all(statusPromises)

      const newStatus = {}
      statuses.forEach(status => {
        newStatus[status.postId] = {
          hasRSPublished: status.hasRSPublished,
          allRSPublished: status.allRSPublished
        }
      })

      this.postsPublicationStatus = newStatus
    },
    isPostFullyPublished (post) {
      return (this.postsPublicationStatus[post.id] && this.postsPublicationStatus[post.id].allRSPublished) || false
    },
    editorialRowClassName ({ row }) {
      return row.etat === 'B' ? 'editorial-brouillon' : ''
    },
    editorialCellStyle ({ row }) {
      if (row.etat === 'B') {
        return { backgroundColor: '#F6C6CE' }
      }
      return {}
    },
    deletePost (selected) {
      // S'assurer que selected est toujours un tableau
      const postsToDelete = Array.isArray(selected) ? selected : [selected]

      if (postsToDelete.length > 0 && postsToDelete[0] && postsToDelete[0].planifications && postsToDelete[0].planifications.length > 0) {
        const planifications = postsToDelete[0].planifications
        this.$store.dispatch('calendarSocialPosts/deletedAllSchedules', planifications)
      }
      this.$store.commit('socialPostsTableEditoriaux/setPostToDelete', postsToDelete)
      this.$store.commit('socialPostsTableEditoriaux/checkDiffusionsPostsToDelete')
      this.$store.commit('socialPostsTableEditoriaux/setModalDelete', true)
      this.selected = []
    },
    editPost (result) {
      if (typeof result === 'object' && result.id) {
        this.$router.push({ name: 'edit-post-editorial', params: { id: result.id } })
      } else {
        this.$router.push({ name: 'edit-post-editorial', params: { id: result } })
      }
    },
    viewPost (result) {
      if (typeof result === 'object' && result.id) {
        this.$router.push({ name: 'view-post-editorial', params: { id: result.id } })
      } else {
        this.$router.push({ name: 'view-post-editorial', params: { id: result } })
      }
    },
    async doSelect (type) {
      if (type === '*') {
        this.selectAllMode = true
        const list = this.socialPostsEditoriaux.list || []
        const existingIds = new Set((this.selected || []).map(s => s.id))
        const toAdd = list.filter(item => !existingIds.has(item.id))
        this.selected = [...(this.selected || []), ...toAdd]
      }
      if (type === null) {
        this.selected = []
        this.selectAllMode = false
      }
    },
    onListSelectionInput (ids) {
      if (!ids || ids.length === 0) {
        this.selected = []
        this.selectAllMode = false
      }
    },
    toggleRowSelection (row, checked) {
      const idx = (this.selected || []).findIndex(s => s.id === row.id)
      if (checked && idx === -1) {
        this.selected = [...(this.selected || []), row]
      } else if (!checked && idx > -1) {
        this.selected = this.selected.filter(s => s.id !== row.id)
      }
    },
    checkNbDiffusionsActives (post) {
      let nbEnvoyees = 0
      if (post.diffusions.length > 0) {
        post.diffusions.forEach(function (element) {
          if (element.firstSentAt) {
            nbEnvoyees = nbEnvoyees + 1
          }
        })
      }
      return nbEnvoyees
    },
    exporter (selection) {
      this.$store.dispatch('socialPostsTableEditoriaux/exportPostsEditoriaux', selection)
    }
  }

}
</script>

<style lang="scss" scoped>
:deep(.SocialPostsTable) {
  .el-table__fixed,
  .el-table__fixed-right {
    display: none;
  }
}

:deep(.social-posts-editoriaux-table .editorial-brouillon td) {
  background-color: #F6C6CE !important;
}

em.el-icon-delete:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
em.el-icon-edit-outline:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
em.el-icon-edit-outline {
  color: #606266 !important;
}
em.el-icon-view {
  color: #606266 !important;
}
</style>
